import WishlistCatalogPanel from '~/js/components/wedding-styler/wishlist-catalog/WishlistCatalogPanel';

const { countries } = beaches_app.page;
let ceremonyCategoryData = [];
const events = [
  {
    value: 31,
    name: 'Ceremony'
  },
  {
    value: 32,
    name: 'Reception'
  }
];

if (Object.keys(window.beaches_app.page.catalogEvents).length > 0) {
  window.beaches_app.page.catalogEvents.forEach((obj) => { // eslint-disable-line

    if (!obj.event) {
      return 0;
    }

    const eventId = obj.event.id;


    obj.subCategories.forEach((subCatObj) => {
      const subCategoryInfo = {
        event: eventId,
        value: subCatObj.id,
        name: `${_.capPhrase(subCatObj.name.toLowerCase())} (${subCatObj.itemCount})`,
        realName: subCatObj.name
      };

      ceremonyCategoryData = [...ceremonyCategoryData, subCategoryInfo];
    });
  });
}

ReactDOM.render(
  <WishlistCatalogPanel
    events = { events }
    ddlData = { ceremonyCategoryData }
    countries = { countries }
  />,
  document.getElementById('catalog-panel')
);
